import cloneDeep from 'lodash/cloneDeep';
import getDeep from 'lodash/get';
import setDeep from 'lodash/set';

function parseKeyPath(key) {
  const parts = key.split('.');
  return parts.length > 1 ? parts[0] : null;
}

/**
 * Updates the value at the specified key in the currentData object.
 * If the valueOrUpdater is a function, it will be called with the current value at the key.
 * If the key represents a deep path, the parent object will be cloned to accommodate a shallow comparison.
 *
 * @param {object} currentData - The object to update.
 * @param {string} key - The key or deep path where the value should be updated.
 * @param {any | Function} valueOrUpdater - The new value or a function that returns the new value.
 * @returns {object} The updated object.
 */
function setter(currentData, key, valueOrUpdater) {
  if (typeof key !== 'string' || key.trim() === '') {
    throw new Error('Key has to be a valid string');
  }
  const isFunction = typeof valueOrUpdater === 'function';
  const value = isFunction ? valueOrUpdater(getDeep(currentData, key)) : valueOrUpdater;

  const root = parseKeyPath(key);
  if (root) {
    // clone the overall parent object to accommodate a shallow comparison
    setDeep(currentData, root, cloneDeep(currentData[root]));
  }
  // set the actual value to change
  setDeep(currentData, key, cloneDeep(value));
  return currentData;
}

export default setter;
